const ROUTE_CONSTANTS = {
    ROOT: {
        RELATIVE: "/",
        ABSOLUTE: "/",
    },
    ROOT_STAR: {
        RELATIVE: "/*",
        ABSOLUTE: "/*",
    },
    AUTH: {
        ROOT: {
            RELATIVE: "auth",
            ABSOLUTE: "/auth",
        },
        LOGIN: {
            RELATIVE: "login",
            ABSOLUTE: "/auth/login",
        },
        SET_PASSWORD: {
            RELATIVE: "set-password",
            ABSOLUTE: "/auth/set-password",
        },
        FORGET_PASSWORD: {
            RELATIVE: "forget-password",
            ABSOLUTE: "/auth/forget-password",
        },
    },
    DASHBOARD: {
        ROOT: {
            RELATIVE: "dashboard",
            ABSOLUTE: "/dashboard",
        },
    },
    PROFILE: {
        ROOT: {
            RELATIVE: "profile",
            ABSOLUTE: "/profile",
        },
    },
    USER_MANAGEMENT: {
        ROOT: {
            RELATIVE: "user-management",
            ABSOLUTE: "/user-management",
        },
        USERS: {
            ROOT: {
                RELATIVE: "users",
                ABSOLUTE: "/user-management/users",
            },
            ADD_NEW: {
                ROOT: {
                    RELATIVE: "users/create",
                    ABSOLUTE: "/user-management/users/create",
                },
            },
            UPDATE: {
                ROOT: {
                    RELATIVE: "users/:id",
                    ABSOLUTE: "/user-management/users/:id",
                },
                EDIT_BY_ID: (id: number) => ({
                    RELATIVE: `users/${id}`,
                    ABSOLUTE: `/user-management/users/${id}`,
                }),
            },
        },
        CUSTOMERS: {
            ROOT: {
                RELATIVE: "customers",
                ABSOLUTE: "/user-management/customers",
            },
            SHOW: {
                ROOT: {
                    RELATIVE: "customers/:id",
                    ABSOLUTE: "/user-management/customers/:id",
                },
                SHOW_BY_ID: (id: number) => ({
                    RELATIVE: `customers/${id}`,
                    ABSOLUTE: `/user-management/customers/${id}`,
                }),
                SUBSCRIPTION_DETAIL: (customerId: string, subscriptionId: number) => ({
                    RELATIVE: `customers/${customerId}/subscription/${subscriptionId}`,
                    ABSOLUTE: `/user-management/customers/${customerId}/subscription/${subscriptionId}`,
                }),
            },
            UPDATE: {
                ROOT: {
                    RELATIVE: "customers/:id/edit",
                    ABSOLUTE: "/user-management/customers/:id/edit",
                },
                EDIT_BY_ID: (id: number) => ({
                    RELATIVE: `customers/${id}/edit`,
                    ABSOLUTE: `/user-management/customers/${id}/edit`,
                }),
            },
        },
        INSTITUTIONS: {
            ROOT: {
                RELATIVE: "institutions",
                ABSOLUTE: "/user-management/institutions",
            },
            ADD_NEW: {
                ROOT: {
                    RELATIVE: "institutions/add",
                    ABSOLUTE: "/user-management/institutions/add",
                },
            },
            UPDATE: {
                ROOT: {
                    RELATIVE: "institutions/edit/:id",
                    ABSOLUTE: "/user-management/institutions/edit/:id",
                },
                EDIT_BY_ID: (id: number) => ({
                    RELATIVE: `institutions/edit/${id}`,
                    ABSOLUTE: `/user-management/institutions/edit/${id}`,
                }),
            },
            DETAILS: {
                ROOT: {
                    RELATIVE: "institutions/details/:id",
                    ABSOLUTE: "/user-management/institutions/details/:id",
                },
                DETAILS_BY_ID: (id: number) => ({
                    RELATIVE: `institutions/details/${id}`,
                    ABSOLUTE: `/user-management/institutions/details/${id}`,
                }),
            },
        },
    },
    CONTENT_MANAGEMENT: {
        ROOT: {
            RELATIVE: "content-management",
            ABSOLUTE: "/content-management",
        },
        CONTENTS: {
            ROOT: {
                RELATIVE: "contents",
                ABSOLUTE: "/content-management/contents",
            },
            SHOW_PUBLISHER: {
                ROOT: {
                    RELATIVE: "publisher",
                    ABSOLUTE: "/content-management/publisher",
                },
            },
            ADD_PUBLISHER: {
                ROOT: {
                    RELATIVE: "publisher/add",
                    ABSOLUTE: "/content-management/publisher/add",
                },
            },
            SHOW_PUBLISHER_DETAILS: {
                ROOT: {
                    RELATIVE: "publisher/details/:id",
                    ABSOLUTE: "/content-management/publisher/details/:id",
                },
                DETAILS_BY_ID: (id: number) => ({
                    RELATIVE: `publisher/details/${id}`,
                    ABSOLUTE: `/content-management/publisher/details/${id}`,
                }),
            },
            UPDATE_PUBLISHER: {
                ROOT: {
                    RELATIVE: "publisher/edit/:id",
                    ABSOLUTE: "/content-management/publisher/edit/:id",
                },
                EDIT_BY_ID: (id: number) => ({
                    RELATIVE: `publisher/edit/${id}`,
                    ABSOLUTE: `/content-management/publisher/edit/${id}`,
                }),
            },
            ADD_NEW_MOVIE: {
                ROOT: {
                    RELATIVE: "contents/create-movie",
                    ABSOLUTE: "/content-management/contents/create-movie",
                },
            },
            UPDATE_MOVIE: {
                ROOT: {
                    RELATIVE: "contents/:id/edit-movie",
                    ABSOLUTE: "/content-management/contents/:id/edit-movie",
                },
                EDIT_BY_ID: (id: number) => ({
                    RELATIVE: `contents/${id}/edit-movie`,
                    ABSOLUTE: `/content-management/contents/${id}/edit-movie`,
                }),
            },
            ADD_NEW_SERIES: {
                ROOT: {
                    RELATIVE: "contents/create-series",
                    ABSOLUTE: "/content-management/contents/create-series",
                },
            },
            UPDATE_SERIES: {
                ROOT: {
                    RELATIVE: "contents/:id/edit-series",
                    ABSOLUTE: "/content-management/contents/:id/edit-series",
                },
                EDIT_BY_ID: (id: number) => ({
                    RELATIVE: `contents/${id}/edit-series`,
                    ABSOLUTE: `/content-management/contents/${id}/edit-series`,
                }),
            },

            SHOW: {
                ROOT: {
                    RELATIVE: "contents/:id",
                    ABSOLUTE: "/content-management/contents/:id",
                },
                SHOW_BY_ID: (id: number) => ({
                    RELATIVE: `contents/${id}`,
                    ABSOLUTE: `/content-management/contents/${id}`,
                }),
            },
        },
        TAGS: {
            ROOT: {
                RELATIVE: "tags",
                ABSOLUTE: "/content-management/tags",
            },
            DETAILS: {
                RELATIVE: "tags/details/:id",
                ABSOLUTE: "/content-management/tags/details/:id",
                BY_ID: (id: number) => ({
                    RELATIVE: `tags/details/${id}`,
                    ABSOLUTE: `/content-management/tags/details/${id}`,
                }),
            },
            ADD_NEW: {
                ROOT: {
                    RELATIVE: "tags/create",
                    ABSOLUTE: "/content-management/tags/create",
                },
            },
            UPDATE: {
                ROOT: {
                    RELATIVE: "tags/:id",
                    ABSOLUTE: "/content-management/tags/:id",
                },
                EDIT_BY_ID: (id: number) => ({
                    RELATIVE: `tags/${id}`,
                    ABSOLUTE: `/content-management/tags/${id}`,
                }),
            },
        },
        GENRES: {
            ROOT: {
                RELATIVE: "genres",
                ABSOLUTE: "/content-management/genres",
            },
            ADD_NEW: {
                ROOT: {
                    RELATIVE: "genres/create",
                    ABSOLUTE: "/content-management/genres/create",
                },
            },
            UPDATE: {
                ROOT: {
                    RELATIVE: "genres/:id",
                    ABSOLUTE: "/content-management/genres/:id",
                },
                EDIT_BY_ID: (id: number) => ({
                    RELATIVE: `genres/${id}`,
                    ABSOLUTE: `/content-management/genres/${id}`,
                }),
            },
        },
    },
    MEDIA_MANAGEMENT: {
        ROOT: {
            RELATIVE: "media-management",
            ABSOLUTE: "/media-management",
        },
        VIDEOS: {
            ROOT: {
                RELATIVE: "videos",
                ABSOLUTE: "/media-management/videos",
            },
            ADD_NEW: {
                ROOT: {
                    RELATIVE: "videos/create",
                    ABSOLUTE: "/media-management/videos/create",
                },
            },
            SHOW: {
                ROOT: {
                    RELATIVE: "videos/:id",
                    ABSOLUTE: "/media-management/videos/:id",
                },
                SHOW_BY_ID: (id: number) => ({
                    RELATIVE: `customers/${id}`,
                    ABSOLUTE: `/media-management/videos/${id}`,
                }),
            },
            UPDATE: {
                ROOT: {
                    RELATIVE: "videos/:id/edit",
                    ABSOLUTE: "/media-management/videos/:id/edit",
                },
                EDIT_BY_ID: (id: number) => ({
                    RELATIVE: `videos/${id}/edit`,
                    ABSOLUTE: `/media-management/videos/${id}/edit`,
                }),
            },
        },
        IMAGES: {
            ROOT: {
                RELATIVE: "images",
                ABSOLUTE: "/media-management/images",
            },
            ADD_NEW: {
                ROOT: {
                    RELATIVE: "images/create",
                    ABSOLUTE: "/media-management/images/create",
                },
            },
            SHOW: {
                ROOT: {
                    RELATIVE: "images/:id",
                    ABSOLUTE: "/media-management/images/:id",
                },
                SHOW_BY_ID: (id: number) => ({
                    RELATIVE: `images/${id}`,
                    ABSOLUTE: `/media-management/images/${id}`,
                }),
            },
        },
        AVATARS: {
            ROOT: {
                RELATIVE: "avatars",
                ABSOLUTE: "/media-management/avatars",
            },
            ADD_NEW: {
                ROOT: {
                    RELATIVE: "avatars/create",
                    ABSOLUTE: "/media-management/avatars/create",
                },
            },
        },
    },
    TRANSACTIONS: {
        ROOT: {
            RELATIVE: "transactions",
            ABSOLUTE: "/transactions",
        },
    },

    APP_UI_MANAGEMENT: {
        ROOT: {
            RELATIVE: "app-ui-management",
            ABSOLUTE: "/app-ui-management",
        },
        HOME: {
            ROOT: {
                RELATIVE: "home",
                ABSOLUTE: "/app-ui-management/home",
            },
            ADD_NEW: {
                ROOT: {
                    RELATIVE: "home/create",
                    ABSOLUTE: "/app-ui-management/home/create",
                },
            },
            UPDATE: {
                ROOT: {
                    RELATIVE: "home/:id",
                    ABSOLUTE: "/app-ui-management/home/:id",
                },
                EDIT_BY_ID: (id: number) => ({
                    RELATIVE: `home/${id}`,
                    ABSOLUTE: `/app-ui-management/home/${id}`,
                }),
            },
            ADD_NEW_SECTION: {
                ROOT: {
                    RELATIVE: "home/section/create",
                    ABSOLUTE: "/app-ui-management/home/section/create",
                },
                EDIT_BY_ID: () => ({
                    RELATIVE: `home/section/create`,
                    ABSOLUTE: `/app-ui-management/home/section/create`,
                }),
            },
            UPDATE_SECTION: {
                ROOT: {
                    RELATIVE: `home/section/:id`,
                    ABSOLUTE: `/app-ui-management/home/section/:id}`,
                },
                EDIT_BY_ID: (id: number) => ({
                    RELATIVE: `home/section/${id}`,
                    ABSOLUTE: `/app-ui-management/home/section/${id}`,
                }),
            },
        },
        CATEGORY_SELECTOR: {
            ROOT: {
                RELATIVE: "category-selector",
                ABSOLUTE: "/app-ui-management/category-selector",
            },
        },
    },
    SETTINGS: {
        ROOT: {
            RELATIVE: "settings",
            ABSOLUTE: "/settings",
        },
        STATIC: {
            ROOT: {
                RELATIVE: "static-page",
                ABSOLUTE: "/settings/static-page",
            },
            ADD_NEW: {
                ROOT: {
                    RELATIVE: "static-page/create",
                    ABSOLUTE: "/settings/static-page/create",
                },
            },
            UPDATE: {
                ROOT: {
                    RELATIVE: "static-page/:id",
                    ABSOLUTE: "/settings/static-page/:id",
                },
                EDIT_BY_ID: (id: number) => ({
                    RELATIVE: `static-page/${id}`,
                    ABSOLUTE: `/settings/static-page/${id}`,
                }),
            },
        },
        COUNTRIES: {
            ROOT: {
                RELATIVE: "countries",
                ABSOLUTE: "/settings/countries",
            },
            CONTENT: {
                ADD_NEW: {
                    ROUTE: {
                        RELATIVE: "countries/create",
                        ABSOLUTE: "/settings/countries/create",
                    },
                    ADD: {
                        RELATIVE: "countries/create",
                        ABSOLUTE: "/settings/countries/create",
                    },
                },
                DETAILS: {
                    ROUTE: {
                        RELATIVE: "countries/:id/details",
                        ABSOLUTE: "/settings/countries/:id/details",
                    },
                    ROOT: (id: number) => ({
                        RELATIVE: `countries/${id}/details`,
                        ABSOLUTE: `/settings/countries/${id}/details`,
                    }),
                },
            },
        },
        PLANS: {
            ROOT: {
                RELATIVE: "plans",
                ABSOLUTE: "/settings/plans",
            },
            ADD_NEW: {
                RELATIVE: "plans/create",
                ABSOLUTE: "/settings/plans/create",
            },
            EDIT: {
                ROUTE: {
                    RELATIVE: `plans/:planId/edit`,
                    ABSOLUTE: `/settings/plans/:planId/edit`,
                },
                ROOT: (id: number) => ({
                    RELATIVE: `plans/${id}/edit`,
                    ABSOLUTE: `/settings/plans/${id}/edit`,
                }),
            },
            DETAILS: {
                ROUTE: {
                    RELATIVE: `plans/:planId`,
                    ABSOLUTE: `/settings/plans/:planId`,
                },
                ROOT: (id: number) => ({
                    RELATIVE: `plans/${id}`,
                    ABSOLUTE: `/settings/plans/${id}`,
                }),
            },
        },
        COUPONS: {
            ROOT: {
                RELATIVE: "coupons",
                ABSOLUTE: "/settings/coupons",
            },
            ADD_NEW: {
                ROOT: {
                    RELATIVE: "coupons/create",
                    ABSOLUTE: "/settings/coupons/create",
                },
            },
            UPDATE: {
                ROOT: {
                    RELATIVE: "coupons/:id",
                    ABSOLUTE: "/settings/coupons/:id",
                },
                EDIT_BY_ID: (id: number) => ({
                    RELATIVE: `coupons/${id}`,
                    ABSOLUTE: `/settings/coupons/${id}`,
                }),
            },
            SHOW: {
                ROOT: {
                    RELATIVE: "coupons/:id/details",
                    ABSOLUTE: "/settings/coupons/:id/details",
                },
                SHOW_BY_ID: (id: number) => ({
                    RELATIVE: `coupons/${id}/details`,
                    ABSOLUTE: `/settings/coupons/${id}/details`,
                }),
            },
        },
        CURRENCY_EXCHANGE: {
            ROOT: {
                RELATIVE: "currency-exchange",
                ABSOLUTE: "/settings/currency-exchange",
            },
        },
    },
    ADMIN_LOGS: {
        ROOT: {
            RELATIVE: "admin-logs",
            ABSOLUTE: "/admin-logs",
        },
    },
    MANUAL_SUBSCRIPTION_SIMPLE: {
        ROOT: {
            RELATIVE: "manual-subscription-simple",
            ABSOLUTE: "/manual-subscription-simple",
        },
    },
    NOT_FOUND: {
        RELATIVE: "not-found",
        ABSOLUTE: "/not-found",
    },
    FORBIDDEN: {
        RELATIVE: "forbidden",
        ABSOLUTE: "/forbidden",
    },
};

export default ROUTE_CONSTANTS;
